<template>
  <div class="d-inline-block" @mouseleave="active = false">
    <div ref="target" @mouseenter="active = true" @click="active = false">
      <slot name="target"></slot>
    </div>
    <teleport to="body">
      <div ref="popup">
        <div v-if="active" class="tooltip" :class="[size]">
          <slot v-if="$slots.content" name="content"></slot>
          <div v-else class="tooltip-body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import {createPopper} from "@popperjs/core";

export default {
  name: "TooltipView",
  props: {
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      }
    },
  },
  data() {
    return {
      popper: undefined,
      active: false
    }
  },
  updated() {
    this.updatePopper();
  },
  mounted() {
    this.popper = createPopper(this.$refs.target, this.$refs.popup, {
      placement: "right",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 8]
          }
        },
        {
          name: 'preventOverflow',
          options: {
            padding: 8,
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ["top", "right", "bottom", "left"],
          },
        },
      ]
    });
  },
  methods: {
    updatePopper() {
      this.popper.state.elements.reference = this.$refs.target;
      this.popper.state.elements.popper = this.$refs.popup;
      this.popper.update();
    }
  },
}
</script>

<style scoped>

</style>